import { useEffect, FC } from "react";
import {
  Link,
  Route,
  Switch,
  useLocation,
  BrowserRouter as Router,
} from "react-router-dom";

import * as Page from "pages";
import { ROUTE } from "route";
import { isBuilding, judgeTheBroswer } from "utils";

import { PrivateRoute, ProvideAuth, AdultRoute } from "routes";

// 不論到哪一頁都會自動回到top
const ScrollToTop: FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};


function App() {

  // 先不偵測是否在 in-app
  // useEffect(() => {
  //   judgeTheBroswer();
  // }, []);

  return (
    <ProvideAuth>
      <Router>
        <ScrollToTop />
        <Switch>
          <Route path={ROUTE.TERMS}><Page.TermsPage /></Route>
          <Route path={ROUTE.PRIVACY}><Page.PrivacyPolicyPage /></Route>
          {/* 需登入頁面 */}

          <Route path={ROUTE.SCAN}><Page.ScanPage /></Route>
          <Route path={ROUTE.SCANNED}><Page.ScannedPage /></Route>
          <Route path={ROUTE.YOUWIN}><Page.YouWinPage /></Route>
          <Route path={ROUTE.YOULOSE}><Page.YouLosePage /></Route>
          <Route path={ROUTE.ANIMA}><Page.AnimaPage /></Route>
          <Route path={ROUTE.PRIVATE}><Page.PrivatePage /></Route>
          <Route path={ROUTE.PCSTEP}><Page.PcStepPage /></Route>

          <PrivateRoute path={ROUTE.RECORD}><Page.RecordPage /></PrivateRoute>

          {/* 免登入頁面 */}
          <AdultRoute path={ROUTE.WINNER}><Page.WinnerPage /></AdultRoute>
          <AdultRoute path={ROUTE.LOGIN}><Page.LoginPage /></AdultRoute>
          <AdultRoute path={ROUTE.LOGINOTHER}><Page.LoginOtherPage /></AdultRoute>
          <Route exact path={ROUTE.INTRO}><Page.IntroPage /></Route>

          <Route exact path={ROUTE.END}><Page.EndPage /></Route>
          <Route exact path={ROUTE.AUTHFB}><Page.AuthFB /></Route>
          <Route exact path={ROUTE.AUTHGOOGLE}><Page.AuthGoogle /></Route>
          <AdultRoute path={ROUTE.HOME}><Page.HomePage /></AdultRoute>
          <Route path="*"><Page.NoMatchPage /></Route>
        </Switch>
        {isBuilding() &&
          <div style={{ opacity: 0 }}>
            <Link to={ROUTE.TERMS}>{ROUTE.TERMS}</Link>
            <Link to={ROUTE.PRIVACY}>{ROUTE.PRIVACY}</Link>
            <Link to={ROUTE.INTRO}>{ROUTE.INTRO}</Link>
            <Link to={ROUTE.SCAN}>{ROUTE.SCAN}</Link>
            <Link to={ROUTE.SCANNED}>{ROUTE.SCANNED}</Link>
            <Link to={ROUTE.YOUWIN}>{ROUTE.YOUWIN}</Link>
            <Link to={ROUTE.YOULOSE}>{ROUTE.YOULOSE}</Link>
            <Link to={ROUTE.WINNER}>{ROUTE.WINNER}</Link>
            <Link to={ROUTE.RECORD}>{ROUTE.RECORD}</Link>
            <Link to={ROUTE.ANIMA}>{ROUTE.ANIMA}</Link>
            <Link to={ROUTE.LOGIN}>{ROUTE.LOGIN}</Link>
            <Link to={ROUTE.LOGINOTHER}>{ROUTE.LOGINOTHER}</Link>
            <Link to={ROUTE.PCSTEP}>{ROUTE.PCSTEP}</Link>
            <Link to={ROUTE.PRIVATE}>{ROUTE.PRIVATE}</Link>
            <Link to={ROUTE.HOME}>{ROUTE.HOME}</Link>
            <Link to={ROUTE.END}>{ROUTE.END}</Link>
            <Link to={ROUTE.AUTHFB}>{ROUTE.AUTHFB}</Link>
            <Link to={ROUTE.AUTHGOOGLE}>{ROUTE.AUTHGOOGLE}</Link>
          </div>
        }
      </Router>
    </ProvideAuth>
  );
}

export default App;
